/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const r = (o) => {
  var n, p;
  return {
    enabled: typeof o == "boolean" ? o : (n = o == null ? void 0 : o.enabled) != null ? n : !0,
    mode: typeof o == "boolean" ? "incell" : (p = o == null ? void 0 : o.mode) != null ? p : "incell"
  };
};
export {
  r as getEditableOptions
};
